const MuiDialog = {
  styleOverrides: {
    paper: ({
      theme
    }) => ({
      borderRadius: 4,
      '& > .MuiButtonBase-root': {
        color: theme.palette.secondary.main,
        '& > [data-testid="CloseIcon"]': {
          fontSize: theme.typography.pxToRem(24)
        }
      },
      '&:not(.MuiDialog-paperFullScreen) > .MuiDialogActions-root': {
        paddingBottom: theme.spacing(2.5)
      }
    })
  }
};
export const MuiDialogTitle = {
  defaultProps: {
    variant: 'h6'
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&.MuiTypography-h1': {
        textAlign: 'left',
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(35),
        lineHeight: '43px',
        color: theme.palette.text.primary,
        paddingLeft: theme.spacing(2.5),
        paddingTop: theme.spacing(3)
      },
      '&.MuiTypography-h6': {
        paddingTop: theme.spacing(5),
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: theme.spacing(3),
        textAlign: 'center',
        fontSize: theme.typography.pxToRem(17),
        fontWeight: 700,
        '& > .MuiSvgIcon-root': {
          display: 'none'
        },
        '& > p.MuiTypography-body1': {
          display: 'none'
        }
      }
    })
  }
};
export const MuiDialogContent = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
      paddingBottom: theme.spacing()
    })
  }
};
export const MuiDialogActions = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(2, 5, 5),
      '& > :not(:first-of-type)': {
        marginLeft: theme.spacing()
      }
    }),
    spacing: ({
      theme
    }) => ({
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5)
    })
  }
};
export default MuiDialog;